import React from 'react'
import { common } from '../constants/constants'
import Large from '../Theme/Typography/Large'

export default function NoMoreToLoad() {
  return (
    <>
    <Large pl={{base:"0",md:"0"}} fontSize="12px" fontWeight='400' color="color.primary" py="2">
        {common.NO_MORE_ITEM_TO_LOAD}
    </Large>
    </>
  )
}
